export const ABOUT_ME_WELCOME_ID = "aboutme_welcome"
export const ABOUT_ME_SKILLS_ID = "aboutme_skills"
export const ABOUT_ME_LIFE_EVENTS_ID = "aboutme_lifeevents"